module.exports = __webpack_public_path__ + "static/media/atendimento_splash.e250aace.png";